import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    dialogTitleV1: {
        fontSize: 16,
        fontWeight: 300,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: '0px !important',
        '& .MuiTypography-root': {
            width: '100%'
        }
    },
    dialogContent: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    divAmount: {
        fontSize: 13, color: '#9ea0a5', fontWeight: 500, marginTop: 16
    },
    divAmount1: {
        fontSize: 13, color: '#9ea0a5', fontWeight: 500
    },
    address: {
        fontSize: 16, fontWeight: 300, marginTop: 24
    },
    divV1: {
        display: 'flex', alignItems: 'center', backgroundColor: 'black', width: '100%', paddingLeft: '12px', justifyContent: 'space-between', paddingRight: '15px'
    },
    divV2: {
        display: 'flex', alignItems: 'center'
    },
    divV3: {
        display: 'flex', flexDirection: 'column', marginLeft: '6px', fontWeight: 300
    },
    divV4: {
        letterSpacing: '0.03em', color: 'white'
    },
    divV5: {
        fontSize: 13, color: 'white'
    },
    cherveRightIcon: {
        marginLeft: 10,
        float: 'right',
        color: '#fff'
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    da1: {
        backgroundColor: '#f1f1f3',
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    divFlex: {
        display: 'flex', justifyContent: 'space-between', fontSize: 16, width: '100%', alignItems: 'center', marginTop: 6
    },
    marginV1: {
        marginTop: 6,
        "& .MuiFormHelperText-root": {
            fontSize: 13
        }
    },
    marginV2: {
        marginTop: 6,
        marginBottom: 16,
        "& .MuiFormHelperText-root": {
            fontSize: 13
        }
    },
    modalWidth: {
        width: 490
    },
    paper1: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    divV7: {
        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: '21px', backgroundColor: '#f1f1f3',
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    locationOnIcon: {
        color: 'white'
    },
    gstNumber: {
        marginTop: 6,
        "& .MuiFormHelperText-root": {
            fontSize: 13
        },
        "& .MuiOutlinedInput-input": {
            textTransform: 'uppercase'
        }
    }
}));

export default useStyles;